<template>
	<div class="relative w-full md:flex py-5 px-5 rounded-lg mb-5 shadow-xl overflow-hidden" :class="colours.card">
		<div class="flex flex-grow">
			<div v-if="data.image.src" class="md:flex md:flex-col mr-4" style="width: 50px; min-width: 50px; max-width: 50px;">
				<div class="md:flex-grow"></div>
				<img style="width: 50px; height: 50px;" class="rounded-lg" :src="data.image.src" alt="" />
				<div class="md:flex-grow"></div>
			</div>
			<div class="flex flex-col flex-grow">
				<div class="flex-grow"></div>
				<div class="w-full">
					<h4 class="block w-full font-sans text-xl leading-tight" :class="colours.title">{{ data.title }}</h4>
					<p class="block w-full font-body text-lg leading-tight">
						<p v-if="data.ad_label" class="inline-block relative align-middle text-xs text-white rounded mr-1" style="padding: 3px 5px 2px; margin-top: -7px;" :class="colours.ad">AD</p>
						<span :class="colours.description">{{ data.description }}</span>
					</p>
				</div>
				<div class="flex-grow"></div>
			</div>
		</div>
		<div v-if="data.button" class="flex flex-col pt-5 md:text-right md:pt-0">
			<div class="flex-grow"></div>
			<a @click="open" @keypress.enter="open" tabindex="0" :class="colours.button" class="block cursor-pointer rounded-lg text-center font-sans text-lg px-5 py-2">{{ data.button.label }}</a>
			<div class="flex-grow"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["data"],
	data() {
		return {
			colour_values: {
				red: {
					card: 'bg-red-70',
					title: 'text-red-800',
					description: 'text-red-1000',
					ad: 'bg-red-800',
					button: 'bg-red-90 text-red-800 hover:bg-red-500 hover:text-white focus:bg-red-500 focus:text-white'
				},
				purple: {
					card: 'bg-purple-90',
					title: 'text-purple-800',
					description: 'text-purple-1000',
					ad: 'bg-purple-800',
					button: 'bg-purple-100 text-purple-800 hover:bg-purple-600 hover:text-white focus:bg-purple-600 focus:text-white'
				},
				grey: {
					card: 'bg-grey-80',
					title: 'text-grey-800',
					description: 'text-grey-900',
					ad: 'bg-grey-800',
					button: 'bg-grey-90 text-grey-900 hover:bg-grey-600 hover:text-white focus:bg-grey-600 focus:text-white'
				},
				blue: {
					card: 'bg-blue-200',
					title: 'text-blue-800',
					description: 'text-blue-900',
					ad: 'bg-blue-800',
					button: 'bg-blue-300 text-blue-900 hover:bg-blue-700 hover:text-white focus:bg-blue-700 focus:text-white'
				},
				pink: {
					card: 'bg-pink-200',
					title: 'text-pink-800',
					description: 'text-pink-900',
					ad: 'bg-pink-800',
					button: 'bg-pink-300 text-pink-900 hover:bg-pink-600 hover:text-white focus:bg-pink-600 focus:text-white'
				},
				teal: {
					card: 'bg-teal-200',
					title: 'text-teal-800',
					description: 'text-teal-900',
					ad: 'bg-teal-800',
					button: 'bg-teal-300 text-teal-900 hover:bg-teal-700 hover:text-white focus:bg-teal-700 focus:text-white'
				},
				orange: {
					card: 'bg-orange-200',
					title: 'text-orange-800',
					description: 'text-orange-900',
					ad: 'bg-orange-800',
					button: 'bg-orange-300 text-orange-900 hover:bg-orange-700 hover:text-white focus:bg-orange-700 focus:text-white'
				},
				yellow: {
					card: 'bg-yellow-200',
					title: 'text-yellow-800',
					description: 'text-yellow-900',
					ad: 'bg-yellow-800',
					button: 'bg-yellow-400 text-yellow-900 hover:bg-yellow-700 hover:text-white focus:bg-yellow-700 focus:text-white'
				}
			},
			colours: {}
		}
	},
	created() {
		var colour = this.data.colour;

		if (!this.data.colour || !this.colour_values[colour]) {
			colour = "red";
		}

		this.colours = this.colour_values[colour];
	},
	methods: {
		open() {
			if (this.data.button.internal) {
				this.$router.push(this.data.button.url);
				return;
			}

			window.open(this.data.button.url, "_blank", "noopener");
		}
	}
}
</script>